export const alloysPartnersShopifyFetchMarkets = "/alloys/partners/shopify/:integration_id/fetch_markets";
